export let important = "UUeYae";
export let hasAttachments = "GHpbw";
export let meeting = "jRIpg";
export let meetingStartsAt = "bn44wb";
export let meetingAccepted = "wc_B1c";
export let meetingDeclined = "htVrLd";
export let meetingTentative = "ta7yKc";
export let meetingCanceled = "GEM93c";
export let conversationCollapsed = "sJVvze";
export let conversationExpanded = "akpeKe";
export let copilotHighPriority = "Ms0hDc";
export let copilotLowPriority = "as1gZc";
export let externalSenderLabel = "_azehe";
export default {important,hasAttachments,meeting,meetingStartsAt,meetingAccepted,meetingDeclined,meetingTentative,meetingCanceled,conversationCollapsed,conversationExpanded,copilotHighPriority,copilotLowPriority,externalSenderLabel};